import { ReactElement, ReactNode } from 'react'
import CommentDrawer from '@editor/components/CommentDrawer'
import PlanImageCardDrawer from '@editor/components/PlanImageCardDrawer'
import PlanTableDrawer from '@editor/components/PlanTableDrawer'

interface Props {
  /** The one plan element type currently selected/active, if any. */
  planElementType: 'comment' | 'image-card' | 'table' | 'element-label' | null
  /** Rendered when `planElementType` isn't one of the three drawer types. */
  fallback?: ReactNode
  /** Shows a close button in the form's header when given. */
  onClose?: () => void
}

/** Picks the drawer for whichever plan element (comment / table / image card) is active. */
const PlanElementDrawer = ({ planElementType, fallback = null, onClose }: Props): ReactElement => {
  switch (planElementType) {
    case 'comment':
      return <CommentDrawer onClose={onClose} />
    case 'table':
      return <PlanTableDrawer onClose={onClose} />
    case 'image-card':
      return <PlanImageCardDrawer onClose={onClose} />
    default:
      return <>{fallback}</>
  }
}

export default PlanElementDrawer
